import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

/**
 * Data payload for updating an AVP chart.
 */
export type AvpChartUpdateData = {
	/**
	 * The ARI of the AVP dashboard containing the chart.
	 */
	dashboardAri: string;
	/**
	 * The identifier of the chart to update.
	 */
	chartId: string;
	/**
	 * The chart data containing chart configuration.
	 */
	chartData: {
		/**
		 * The chart configuration.
		 */
		chart: SerializableValue;
	};
};

/**
 * Properties for the AVP chart update command.
 *
 * @extends CommandProperties
 */
export interface AvpChartUpdateCommandProperties extends CommandProperties {
	/**
	 * The unique key identifier for the chart update request.
	 */
	key: string;
	/**
	 * The data payload containing the chart identifier and updated configuration.
	 */
	data: AvpChartUpdateData;
	/**
	 * Whether the stream is complete.
	 */
	isStreamComplete: boolean;
}

/**
 * A command sent by a bridge API client to update an AVP chart.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to update an AVP chart with the specified identifiers and configuration.
 */
export const AvpChartUpdateCommand: CommandConstructor<
	AvpChartUpdateCommandProperties,
	SerializableValue
> = createCommand<AvpChartUpdateCommandProperties>('avp-chart-update-command');
